module.exports = __webpack_public_path__ + "static/VBA-e586092e6900a718f7c153286e209a7d.svg";